<template>
    <div class="conatiner" v-if="!isPageLoading">
        <div class="search-container">
            <img
                src="../../assets/bg_hero-wide.jpg"
                alt=""
                class="top-cover"
                v-if="!banner.url"
            />
            <img :src="banner.url" alt="" class="top-cover" v-else/>
            <div class="content">
                <div class="title">
                    {{ $t("newAdd.add3") }}
                </div>
                <div class="input-container" v-if="storesAllList.length != 0">
                    <input
                        type="text"
                        placeholder="Tu codigo postal"
                        v-model="keyword"
                        @keyup.enter="searchLocal"
                    />
                    <div class="btn" @click="searchLocal">Buscar</div>
                </div>
                <div class="input-container" v-if="storesAllList.length == 0">
                    <input
                        type="text"
                        :placeholder="$t('newAdd.add3')"
                        v-model="keyword"
                        @keyup.enter="searchServe"
                    />
                    <div class="btn" @click="searchServe">Buscar</div>
                </div>
            </div>
        </div>

        <!-- begin 未结束订单 -->
        <div class="order-list-home">
            <div :key="index" class="order-item" v-for="(item, index) in orderList">
                <div v-if="item.status < 4" @click="goToOrderDetail(item)">
                    {{ $t("index.order") }}
                </div>
            </div>
        </div>
        <!-- end 未结束订单 -->

        <div v-if="pageLoading" class="page-loading-container">
            <v-progress-circular
                :size="60"
                :width="5"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </div>

        <div v-if="!pageLoading && storesList.length == 0" class="none-tips">
          {{ $t("newAdd.add4") }}
        </div>
        <div class="list">
            <div
                class="item"
                v-for="(item, index) in storesList"
                :key="index"
                @click="goToDetail(item)"
                v-show="item.deliveryType != 2"
            >
                <div class="cover">
                    <img :src="item.logo.url" alt="" v-if="item.logo" class="avatar"/>
                </div>
                <div class="food-container">
                    <div class="food-title">{{ item.name }}</div>
                    <div class="grey-text">{{ item.address.address1 }}</div>
                    <div class="grey-text">
                        <!-- {{ item.address.city }} -->
                        {{ item.show_zipcode }}
                    </div>
                </div>
                <!-- <div class="store-container">
                  <div class="store-title">店铺名称</div>
                  <div class="grey-text">地址</div>
                  <div class="grey-text">
                    邮编
                    <span>城市</span>
                  </div>
                </div> -->
            </div>
            <div
                class="item"
                v-for="(item, index) in storesList"
                :key="index"
                @click="goToDetailDeliveryType2(item)"
                v-show="item.deliveryType == 2"
            >
                <div class="cover">
                    <img :src="item.logo.url" alt="" v-if="item.logo" class="avatar"/>
                </div>
                <div class="food-container">
                    <div class="food-title">{{ item.name }}</div>
                    <div class="grey-text">{{ item.address.address1 }}</div>
                    <div class="grey-text">
                        <!-- {{ item.address.city }} -->
                        {{ item.show_zipcode }}
                    </div>
                </div>
                <!-- <div class="store-container">
                  <div class="store-title">店铺名称</div>
                  <div class="grey-text">地址</div>
                  <div class="grey-text">
                    邮编
                    <span>城市</span>
                  </div>
                </div> -->
            </div>
            <!-- <div class="item">
              <div class="cover">
                <img src="../../assets/bg_hero-wide.jpg" alt="" class="avatar" />
              </div>
              <div class="food-container">
                <div class="food-title">KFC Manchrster Oxgord Road</div>
                <div class="grey-text">M10.4 miles</div>
                <div class="grey-text">Chicken</div>
                <v-rating v-model="rating" dense readonly></v-rating>
              </div>
              <div class="store-container">
                <div class="store-title">店铺名称</div>
                <div class="grey-text">地址</div>
                <div class="grey-text">
                  邮编
                  <span>城市</span>
                </div>
              </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import store from "@/api/store";
import order from "@/api/order";

export default {
    data: () => ({
        storesList: [],
        storesAllList: [],
        keyword: "",
        pageLoading: false,
        banner: {url: ""},
        orderList: [],

        isPageLoading: false
    }),

    computed: {
        ...mapState(["zipCode", "storeId", "guid", "tokenContent", "storeInfo"])
    },

    created() {
        localStorage.setItem("keyword", false);
        this.loadAllStore();
        if (this.zipCode) {
            this.keyword = this.zipCode;
            this.searchLocal();
        }
        this.getBanner();

        if (this.tokenContent) {
            this.loadOrder();
        }

        this.isPageLoading = true;
        store
            .getStart()
            .then(res => {
                if(sessionStorage.getItem('initRedirect')) return ;
                if (!res.data.isError && res.data.data && res.data.data.guid) {
                    this.goToDetail(res.data.data, true);
                }
            })
            .finally(() => {
                setTimeout(() => {
                    this.isPageLoading = false;
                }, 50);
            });
    },

    methods: {
        ...mapMutations(["setStoreId", "setZipCode", "setKeyword", "setStoreInfo"]),
        async loadAllStore() {
            console.log('loadAllStore', new Date().getTime())
            this.pageLoading = true;
            try {
                let res = await store.getAllStore({});
                if (!res.data.isError) {
                    this.pageLoading = false;
                    res.data.data.map((item, index) => {
                        let zipCodeArr = [];

                        item.deliveryArea.map(areaItem => {
                            zipCodeArr.push(areaItem.zipCode);
                        });

                        res.data.data[index].show_zipcode = zipCodeArr.join(", ");
                    });

                    this.storesList = res.data.data;
                    console.log(
                        "测试这里所有商铺",
                        this.storesList,
                        this.storesList.deliveryType
                    );

                    this.storesAllList = res.data.data;
                } else {
                    this.tip = res.data.msg;
                    this.passwordTip = true;
                }
            } catch (e) {
                this.tip = e.response.data.msg;
                this.passwordTip = true;
            }
        },

        async getBanner() {
            try {
                const res = await store.getBanner({});
                if (!res.data.isError && res.data.data) {
                    this.banner = res.data.data;
                }
            } catch (e) {
                console.log(e);
            }
        },

        // 根据邮编搜索店铺
        async searchServe() {
            this.pageLoading = true;
            try {
                const res = await store.getZipcodeStore({zipcode: this.keyword});

                if (!res.data.isError) {
                    this.pageLoading = false;

                    res.data.data.map((item, index) => {
                        let zipCodeArr = [];

                        item.deliveryArea.map(areaItem => {
                            zipCodeArr.push(areaItem.zipCode);
                        });

                        res.data.data[index].show_zipcode = zipCodeArr.join(", ");
                    });

                    this.storesList = res.data.data;
                    console.log("根据邮编搜索店铺", this.storesList);
                } else {
                    this.tip = res.data.msg;
                    this.passwordTip = true;
                }
            } catch (e) {
                this.tip = e.response.data.msg;
                this.passwordTip = true;
            }
        },

        // 本地店铺搜索
        searchLocal() {
            if (!this.keyword) {
                this.storesList = this.storesAllList;
                return;
            }
            let storesList = [];
            this.storesAllList.map(item => {
                let isSame = false;
                item.deliveryArea.map(areaItem => {
                    const a = areaItem.zipCode + "";
                    const b = this.keyword + "";
                    if (a.indexOf(b) > -1) {
                        isSame = true;
                    }
                });
                if (isSame) {
                    this.goToDetail(item);
                    storesList.push(item);
                }
            });
            this.storesList = storesList;
            console.log("本地店铺搜索", this.storesList);
        },

        goToDetail(item, start) {
            console.log("this.keyword--", this.keyword);
            let $this = this;
            this.setStoreId(item.guid);
            console.log(
                "查看这是什么",
                item,
                item.deliveryArea,
                item.deliveryArea.length
            );
            localStorage.setItem("deliveryType", item.deliveryType);
            if (item.deliveryArea && item.deliveryArea.length) {
                if (this.keyword != "") {
                    console.log("进入不为空", this.keyword);
                    this.setZipCode(this.keyword);
                    localStorage.setItem("keyword", true);
                    this.setKeyword(true);
                    // this.$router.push({ name: "home" });
                } else {
                    console.log("进入空", this.keyword);
                    this.setKeyword(false);
                    this.setZipCode(item.deliveryArea[0].zipCode);
                    localStorage.setItem("keyword", false);
                    // this.getIndexStorInfo(this.keyword);
                }
            }
            if(start){
                if(item.showStart) sessionStorage.setItem('initRedirect', 1);
                let home_page_show = item.storeConf && item.storeConf.home_page_show;
                if(home_page_show === 2){
                    $this.$router.push({name: "about"});
                }else if(home_page_show === 1){
                    $this.$router.push({name: "index"});
                }else{
                    $this.$router.push({name: "home"});
                }
            }else{
                $this.$router.push({name: "home"});
            }
        },
        goToDetailDeliveryType2(item) {
            console.log("进入第一种配送方式", item);
            this.setStoreId(item.guid);
            // this.setZipCode("");
            this.$router.push({path: "/delivery/list"});
        },
        async loadOrder() {
            try {
                const res = await order.loadOrder({pageIndex: 1, pageSize: 3});
                if (!res.data.isError) {
                    this.orderList = res.data.data.collection;
                }
            } catch (e) {
                console.log(e);
            }
        },

        goToOrderDetail(item) {
            this.$router.push({name: "order/detail", params: {guid: item.guid}});
        },
        async getIndexStorInfo(id) {
            try {
                const {
                    data: {isError, data}
                } = await store.getStoreInfo({guid: id});

                if (isError) {
                    return;
                }
                this.setStoreInfo(data);
                this.$router.push({name: "home"});
            } catch (e) {
                console.log(e);
            }
        }
    }
};
</script>

<style lang="sass" scoped src="./index.sass"></style>
